// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__Snm3s","title":"ClientReferral_title__1NwbG","itemText":"ClientReferral_itemText__3lgnA"};